// extracted by mini-css-extract-plugin
module.exports = {"beta-badge":"assessment-beta-badge_beta-badge__4pYjh"};